import GoogleMapReact from "google-map-react";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import {useTranslation} from "react-i18next";

const ContactMap = () => {
    const {t} = useTranslation()
    const handleApiLoaded = (map: any, maps: any) => {
        map.setOptions({
            center: { lat: -25.782766, lng: 28.264924 },
            zoom: 15,
            scrollwheel: false,
            streetViewControl: false,
            styles: [
                {
                    stylers: [{ saturation: -90 }],
                },
            ],
            mapTypeControlOptions: {
                mapTypeIds: [],
            },
        });

        new maps.Marker({
            position: { lat: -25.782766, lng: 28.264924 },
            map: map,
            title: "hearX Group",
        });
    };

    return (
        <div className="w-full h-96" title={t("contact.maps.seo.title")} aria-label={t("contact.maps.seo.aria-label")}>
            <LazyLoadComponent>
                <GoogleMapReact
                    bootstrapURLKeys={{ key: process.env.NEXT_PUBLIC_GOOGLE_MAPS_ID ? process.env.NEXT_PUBLIC_GOOGLE_MAPS_ID : "" }}
                    defaultCenter={{
                        lat: -25.782766,
                        lng: 28.264924,
                    }}
                    defaultZoom={15}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map, maps }) => handleApiLoaded(map, maps)}
                />
            </LazyLoadComponent>
        </div>
    );
};

export default ContactMap;
